module.exports = __webpack_public_path__ + "static/media/takeTwoNines_1.d4932b33.png";